import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import online from "../../images/landingPage/online.svg";
import HomeNavBar from "../components/HomeNavBar";
import { useSelector, useDispatch } from "react-redux";
import Footer from "../components/Footer";
import { searchByCertifications } from "../../actions/home/home_action";
import CertificationShowModal from "./CertificationShowModal";
import { addElementToCart } from "../../actions/home/cart_action";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const HomeAllCertifications = () => {
  const state = useSelector((state) => state.homeReducer);
  const cartState = useSelector((state) => state.cartReducer);
  const [certificationData, setCertificationData] = useState({});
  const [certificationModal, setCertificationModal] = useState(false);
  const dispatch = useDispatch("");
  const [search, setSearch] = useState();
  const [type, setSelectType] = useState("AWS");
  useEffect(() => {
    dispatch(searchByCertifications({ search: search }));
  }, []);

  const certificationContentData = (li) => {
    setCertificationModal(true);
    setCertificationData(li);
  };

  const resetCertificationData = () => {
    setCertificationModal(false);
    setCertificationData({});
  };

  const searchCertifications = () => {
    dispatch(searchByCertifications({ search: search, type: type }));
  };

  const deviceKey = localStorage.getItem("uu");
  const addToCart = (data) => {
    dispatch(
      addElementToCart({
        type: "is_certificate",
        type_id: data.id,
        price: data.cost_doller,
        device_key: deviceKey,
      })
    );
  };

  if(cartState.is_done ) {
    toast("Certification Added Into Cart!", {
      type: "success",
      position: "top-center",
    });
  }

  const navigate = useNavigate();
  const getMoreDetails = (id) => {
    navigate("/certification-details/" + window.btoa(id));
  };
  //convert ID window.btoa(id);
  const searchBySelect = (type) => {
    setSelectType(type);
    dispatch(searchByCertifications({ search: search, type: type }));
  };

  return (
    <LoadingOverlay
      active={state.loading || cartState.loading}
      spinner
      text="Loading..."
    >
      <div className="main-landing-page traning-landing-page landing-container">
        {/* navbar */}
        <HomeNavBar />
        <div className="container-fluid">
          <ToastContainer />
          <div className="row cource-section">
            <div className="col-12">
              <div className="titlepage">
                <h1 className="color-white">Certifications</h1>
              </div>
            </div>
            <div className="col-sm-12 col-md-2 col-lg-2 search-course">
              <select
                className="form-control serach-text-course select-cert"
                onChange={(e) => searchBySelect(e.target.value)}
              >
                <option value={"AWS"}>AWS</option>
                <option value={"Google"}>Google</option>
                <option value={"Microsoft"}>Microsoft</option>
                <option value={"All"}>All</option>
              </select>
            </div>
            <div className="col-sm-12 col-md-10 col-lg-10 search-course">
              <input
                type="text"
                placeholder="Search Certification"
                className="form-control serach-text-course sr-cert"
                onChange={(e) => {
                  setSearch(e.target.value);
                  if (e.target.value === "") {
                    dispatch(searchByCertifications({ search: "" }));
                  }
                }}
              />
              <button
                className="btn-common sr-btn"
                type="button"
                onClick={() => searchCertifications()}
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div className="row cource-section">
            {state.certifications.map((li, i) => (
              <div className="col-lg-4 mb-3">
                <div className="box">
                  <i
                    className={
                      li.certification_type === "AWS"
                        ? "fa fa-aws cert-icon"
                        : li.certification_type === "Google"
                        ? "fa fa-google cert-icon"
                        : "fa fa-microsoft cert-icon"
                    }
                  ></i>
                  <h4 className="title certification-nm">
                     <span className="certification-nm">{li.name}</span>
                  </h4>
                  <div className={"cer-btn-div"}>
                    <button className="btn-common cert-btns">Live</button>
                    <br />
                    <button className="btn-common cert-btns">Videos</button>
                    <br />
                    <button className="btn-common cert-btns">Request</button>
                  </div>                  
                  <br/>

                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        title={"See More Details"}
                        className="btn-common cert-btns"
                        onClick={() => getMoreDetails(li.id)}
                      >
                        More Details
                      </button>
                      <button
                        title="Add to cart"
                        className="btn-common cert-btns"
                        onClick={() => addToCart(li, "is_certificate")}
                      >
                        <i
                          class="fa fa-shopping-cart btn-cart"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                    <div className="col-lg-6">
                      <span className="cert-price">${li.cost_doller}</span>
                    </div>
                  </div>
                  
                </div>
              </div>
            ))}
          </div>

          {/* <div className="row cource-section">
            {state.certifications.map((li, i) => (
              <div className="col-lg-4 mb-3" key={i}>
                <div className="box">
                  <div className="row">
                    <div className="col-xs-12 col-12">
                      <h4 className="title certification-nm">
                        <span className="certification-nm">{li.exam}</span>
                      </h4>
                      </div>
                    <br />
                    <div className="col-xs-6 col-6">
                      <h6 className="cer-details">{li.certification_type}</h6>
                      <h6 className="cer-details">{li.level}</h6>
                      <h6 className="cer-details">{li.product_name}</h6>
                    </div>

                    <div className="col-xs-6 col-6 align-c">
                      <img className="" src={online} alt="First slide" />
                    </div>

                    <div className="col-5">
                      <button
                        onClick={() => addToCart(li)}
                        className="btn-common"
                      >
                        Add to Cart
                      </button>
                    </div>
                    <div className="col-7  align-r">
                      <a
                        className="mr-14"
                        onClick={() => certificationContentData(li)}
                      >
                        Certification Content
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>*/}
        </div>
        {/* footer */}
        <Footer />
      </div>
      {certificationModal && (
        <CertificationShowModal
          show={certificationModal}
          certificationData={certificationData}
          handelCloseShow={() => resetCertificationData()}
        />
      )}
    </LoadingOverlay>
  );
};

export default HomeAllCertifications;
